import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import config from '../../config';
import {
  Page,
  SectionHero,
  SectionHowItWorks,
  SectionOne,
  SectionOneNew,
  SectionTwo,
  SectionThree,
  SectionThreeNew,
  SectionContact,
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';

import facebookImage from '../../assets/uupo-share-facebook-1200x630.png';
import css from './LandingPage.module.css';
import { getListingsById } from '../../ducks/marketplaceData.duck';

export const LandingPageComponent = props => {
  const { history, intl, location, scrollingDisabled, latestListings } = props;

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'LandingPage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${facebookImage}`;

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      primaryKeywords={intl.formatMessage({ id: 'LandingPage.keywords' })}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.heroContainer}>
            <SectionHero
              className={css.hero}
              history={history}
              location={location}
              isAuthenticated={props.isAuthenticated}
            />
          </div>
          <ul className={css.sections}>
            <li>
              {/* <SectionOne latestListings={latestListings.slice(0, 3)} msg='SectionOne.browseButton' /> */}
              <SectionOneNew />
            </li>
            <li className={css.section}>
              <SectionTwo />
            </li>
            <li className={css.section}>
              {/* <SectionThree /> */}
              <SectionThreeNew />
            </li>
            {/* <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionHowItWorks />
              </div>
            </li> */}
            <li className={css.section}>
              <div className={css.sectionContent}>
                <SectionContact />
              </div>
            </li>
          </ul>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool, object } = PropTypes;

LandingPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from withRouter
  history: object.isRequired,
  location: object.isRequired,

  isAuthenticated: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { latestListingsIds } = state.LandingPage;
  const { isAuthenticated } = state.Auth;
  const latestListings = getListingsById(state, latestListingsIds);
  return {
    latestListings: latestListings,
    scrollingDisabled: isScrollingDisabled(state),
    isAuthenticated,
  };
};

// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(withRouter, connect(mapStateToProps), injectIntl)(LandingPageComponent);

export default LandingPage;
